import { render, staticRenderFns } from "./CardMain.vue?vue&type=template&id=ef79b3e8"
import script from "./CardMain.vue?vue&type=script&lang=ts"
export * from "./CardMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports